import { render, staticRenderFns } from "./MultiColumnLedger.vue?vue&type=template&id=40500ac6&scoped=true"
import script from "./MultiColumnLedger.vue?vue&type=script&lang=js"
export * from "./MultiColumnLedger.vue?vue&type=script&lang=js"
import style0 from "./MultiColumnLedger.vue?vue&type=style&index=0&id=40500ac6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40500ac6",
  null
  
)

export default component.exports